export default "__VITE_ASSET__C3X1Rfzh__"